const state = {
	stockLoging: false,
}
  
const mutations = {
	toggleStockLoading(state,payload){
        state.stockLoging = payload
    }
}

const actions = {

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
  